import { render, staticRenderFns } from "./AppManagement.vue?vue&type=template&id=0955f193&"
import script from "./AppManagement.vue?vue&type=script&lang=js&"
export * from "./AppManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports